import React, { useState, useEffect, useCallback } from "react";
import { Col, Form } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import "rc-datepicker/lib/style.css";
import {
  getMenuData,
  getlistClass,
  getEvaluations,
  getEntrypointsHasElements,
} from "../../../../../services/NexiDigitalAPI";
import FiltroWrapper from "../../../Components/FiltroWrapper";
import styles from "containers/Reports/ReportsLearningTraining/styles.module.scss";
import ButtonWithLoading from "../../../../../components/ButtonWithLoading";
import CatalogModal from "containers/PeopleCraft/NodeManagerV2/CatalogModal";
import useSelectOptions from "hooks/useSelectOptions";
import ClearTrainingButton from "../../../Components/ClearTrainingButton";

const Filter = ({ actionFilter, loading, expanded, downloadEvent }) => {
  const initialStateSelect = [
    {
      value: "all",
      label: "Todas",
    },
  ];
  const initialFormStates = {
    idEvaluation: "",
    idTeam: "all",
    nodeCode: "all",
    idCompany: getMenuData().idCompany,
    offset: 0,
    limit: 10,
  };
  const [formData, setFormData] = useState(initialFormStates);
  const [evaluations, setEvaluations] = useState([]);
  const [learnings, setLearnings] = useState(initialStateSelect);
  const [selectedTraining, setSelectedTraining] = useState(null);
  const [showCatalog, setShowCatalog] = useState(false);
  const [loadingEvaluations, setLoadingEvaluations] = useState(false);
  const [loadingLearnings, setLoadingLearnings] = useState(false);

  const defineNodeCode = useCallback((node) => {
    return node.originCode ?? node.nodeCode;
  }, []);

  async function getConsolidatedKnowledgeEvaluations() {
    setLoadingEvaluations(true);
    try {
      const { result } = await getEvaluations({
        idCompany: getMenuData().idCompany,
        evaluationType: "KNOWLEDGE",
        hasQuestionnaire: true,
      });

      if (result.length) {
        const formatedData = result.map(({ idEvaluation, title }) => ({
          value: idEvaluation,
          label: title,
        }));
        setEvaluations(formatedData);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingEvaluations(false);
    }
  }

  async function getLearnings(nodeCode) {
    setLoadingLearnings(true);
    try {
      const learningResBase = await getlistClass(nodeCode);
      const learningRes = learningResBase.result;

      if (learningRes.length) {
        const formatedData = learningRes.map(({ idTeam, name }) => ({
          value: idTeam,
          label: name,
        }));

        setLearnings([...initialStateSelect, ...formatedData]);
      } else {
        setLearnings(initialStateSelect);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingLearnings(false);
    }
  }

  function handleFilter() {
    return actionFilter({
      ...formData,
      idTeam: formData.idTeam === "all" ? undefined : formData.idTeam,
      nodeCode: formData.nodeCode === "all" ? undefined : formData.nodeCode,
      idCompany: getMenuData().idCompany,
    });
  }

  const handleChangeSelect = async ({ target }) => {
    const { name, value } = target;
    if (name === "evaluations") {
      setFormData((prevData) => ({
        ...prevData,
        idEvaluation: value,
        nodeCode: "all",
        idTeam: "all",
      }));

      setSelectedTraining(null);
      setLearnings(initialStateSelect);
    }
    if (name === "trainings") {
      setFormData((prevData) => ({
        ...prevData,
        nodeCode: value,
        idTeam: "all",
      }));
      if (value && value !== "all") {
        getLearnings({ nodeCode: value });
      } else {
        setLearnings(initialStateSelect);
      }
    }
    if (name === "learnings") {
      setFormData((prevData) => ({
        ...prevData,
        idTeam: value,
      }));
    }
  };

  function updateStates() {
    setFormData(initialFormStates);
    getConsolidatedKnowledgeEvaluations();
    setLearnings(initialStateSelect);
  }

  useEffect(() => {
    setEvaluations([]);
    setSelectedTraining(null);
    setLearnings([]);
  }, []);

  useEffect(() => {
    if (!expanded) {
      setEvaluations([]);
      setSelectedTraining(null);
    }

    updateStates();
  }, [expanded]);

  const getDisabledStyle = (enabled) => ({
    pointerEvents: enabled ? "auto" : "none",
    backgroundColor: enabled ? undefined : "#f5f5f5",
    color: enabled ? undefined : "#aaa",
    cursor: enabled ? "pointer" : "not-allowed",
  });

  const evaluationOptions = useSelectOptions(evaluations, loadingEvaluations, {
    label: "Selecionar",
    value: "",
  });

  const learningOptions = useSelectOptions(learnings, loadingLearnings);

  const onClear = (e) => {
    e.stopPropagation();
    setSelectedTraining(null);
    setFormData((prev) => ({ ...prev, nodeCode: "all", idTeam: "all" }));
    setLearnings(initialStateSelect);
  };

  return (
    <FiltroWrapper>
      <Form style={{ marginTop: 30, marginBottom: 30 }}>
        <Form.Row className="align-items-end">
          <Col xs={12} md={3} lg={3} className={styles.customFormSpace}>
            <Form.Label htmlFor="evaluations">Avaliação*</Form.Label>
            <div style={{ position: "relative" }}>
              <Form.Control
                id="evaluations"
                name="evaluations"
                as="select"
                value={formData.idEvaluation}
                onChange={handleChangeSelect}
                disabled={loading || loadingEvaluations}
              >
                {evaluationOptions}
              </Form.Control>
            </div>
          </Col>
          <Col xs={12} md={3} lg={3} className={styles.customFormSpace}>
            <Form.Label htmlFor="trainings">Treinamento</Form.Label>
            <div style={{ position: "relative" }}>
              <div
                className={styles.trainingSelectDiv}
                onClick={() => {
                  if (formData.idEvaluation && !loading) setShowCatalog(true);
                }}
                style={getDisabledStyle(!!formData.idEvaluation && !loading)}
                aria-disabled={!formData.idEvaluation || loading}
                tabIndex={!formData.idEvaluation || loading ? -1 : 0}
                title={
                  selectedTraining
                    ? `${selectedTraining.nodeCode} - ${selectedTraining.title}`
                    : "Selecionar treinamento"
                }
              >
                <span className={styles.trainingSelectText}>
                  {selectedTraining
                    ? `${selectedTraining.nodeCode} - ${selectedTraining.title}`
                    : "Selecionar treinamento"}
                </span>
                {selectedTraining && (
                  <span style={{ marginLeft: 8, flexShrink: 0 }}>
                    <ClearTrainingButton
                      onClear={onClear}
                      disabled={loading || loadingEvaluations}
                      className={styles.cleanTrainingButton}
                    />
                  </span>
                )}
              </div>
            </div>
            {showCatalog && (
              <CatalogModal
                denyAction={() => setShowCatalog(false)}
                title="Selecione o treinamento vinculado à avaliação que você precisa"
                subTitle="Todos os treinamentos listados abaixo possuem esta avaliação."
                returnNodeData={(node) => {
                  setSelectedTraining(node);
                  setFormData((prev) => ({
                    ...prev,
                    nodeCode: defineNodeCode(node) || "all",
                  }));
                  setShowCatalog(false);
                  if (node?.nodeCode) {
                    getLearnings({ nodeCode: defineNodeCode(node) });
                  } else {
                    setLearnings(initialStateSelect);
                  }
                }}
                requestListNode={() =>
                  getEntrypointsHasElements({
                    entityType: "EVALUATION",
                    idEntity: Number(formData.idEvaluation),
                  })
                }
                isSimpleSelect={true}
                nodeType={"LEARNING"}
                onlyEntrypoints={true}
                disableRequestChildNodes={true}
              />
            )}
          </Col>
          <Col xs={12} md={2} lg={2} className={styles.customFormSpace}>
            <Form.Label htmlFor="learnings">Turma</Form.Label>
            <div style={{ position: "relative" }}>
              <Form.Control
                id="learnings"
                name="learnings"
                as="select"
                value={formData.idTeam}
                onChange={handleChangeSelect}
                disabled={!formData.idEvaluation || loading || loadingLearnings}
              >
                {learningOptions}
              </Form.Control>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} className={styles.customFormSpace}>
            <Form.Group className="mb-0">
              <ButtonWithLoading
                disabled={!formData.idEvaluation || loading}
                onClickHandler={handleFilter}
                loading={loading}
                text={
                  <>
                    Aplicar filtro <FaFilter style={{ marginLeft: 5 }} />
                  </>
                }
                style={{ width: "100%" }}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={2} lg={2} className={styles.customFormSpace}>
            <Form.Group className="mb-0">
              <ButtonWithLoading
                disabled={!formData.idEvaluation || loading}
                onClickHandler={downloadEvent}
                loading={loading}
                text={<>Download da planilha</>}
                style={{ width: "100%", backgroundColor: "#0d6efd", borderColor: "#0d6efd" }}
              />
            </Form.Group>
          </Col>
        </Form.Row>
      </Form>
    </FiltroWrapper>
  );
};

export default Filter;
